var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtCardClock = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h70v70H0V0z",
    id: "nnek91if1a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#nnek91if1a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h70v70H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(3.962 3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1C2D36",
    d: "m24.062 14.207-.757.432-3.315-6.162.757-.432zM11.224 16.264l-.964.852-4.456-5.344.964-.852z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C2D36",
    d: "m14.155 20.138-.964.852-4.456-5.344.964-.852zM34.116 6.976 34.192.72a.717.717 0 0 1 .757-.718l.332.023a.722.722 0 0 1 .658.741l-.117 6.346-1.706-.136z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.148 9.154a6.97 6.97 0 0 0-.012-1.401c-.06-.544-.235-1.96-1.236-3.21-.484-.605-.967-.929-1.495-1.274-1.046-.688-2-.959-3.643-1.428a13.448 13.448 0 0 0-1.412-.342c-.407-.07-1.032-.15-2.229-.147-1.123.004-1.796.006-2.716.151 0 0-1.808.286-3.766 1.281a3.478 3.478 0 0 0-1.01.726c-.317.336-.49.663-.684 1.04-.15.29-.286.673-.56 1.438-.28.782-.377 1.124-.403 1.573-.011.192-.006.35 0 .455",
    fill: "#007C96"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#006C7F",
    transform: "rotate(-87.14 34.49 8.66)",
    cx: 34.489,
    cy: 8.659,
    rx: 4.046,
    ry: 9.644
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#1C2D34",
    transform: "rotate(-20.05 30.462 33.977)",
    cx: 30.462,
    cy: 33.977,
    rx: 22.441,
    ry: 22.086
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.427 53.637-1.083 7.627a.307.307 0 0 1-.027.09l-1.531 3.45c-.14.316-.596.23-.62-.115l-.265-3.743a.427.427 0 0 1 .004-.083l1.292-7.594a.327.327 0 0 1 .372-.273l1.586.26a.334.334 0 0 1 .27.38h.002z",
    fill: "#007C96"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C2D36",
    d: "m35.85 4.693-.143 7.028-1.748-.142.186-7.037z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#007C96",
    transform: "rotate(-20.05 33.828 32.69)",
    cx: 33.828,
    cy: 32.69,
    rx: 20.953,
    ry: 22.086
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    transform: "rotate(-20.05 33.527 32.545)",
    cx: 33.527,
    cy: 32.545,
    rx: 18.464,
    ry: 19.462
  }), /*#__PURE__*/React.createElement("text", {
    transform: "rotate(-29.46 44.974 -36.245)",
    fill: "#231F20",
    fontFamily: "Helvetica",
    fontSize: 4.245
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4
  }, "12")), /*#__PURE__*/React.createElement("text", {
    transform: "rotate(-29.46 103.219 -51.978)",
    fill: "#231F20",
    fontFamily: "Helvetica",
    fontSize: 4.245
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4
  }, "6")), /*#__PURE__*/React.createElement("text", {
    fill: "#231F20",
    transform: "rotate(-29.46 46.971 24.055)",
    fontFamily: "Helvetica",
    fontSize: 4.245
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 45.471,
    y: 25.555
  }, "3")), /*#__PURE__*/React.createElement("text", {
    transform: "rotate(-29.46 81.19 -14.847)",
    fill: "#231F20",
    fontFamily: "Helvetica",
    fontSize: 4.245
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4
  }, "9")), /*#__PURE__*/React.createElement("text", {
    transform: "rotate(-29.46 45.08 -53.032)",
    fill: "#231F20",
    fontFamily: "Helvetica",
    fontSize: 4.245
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4
  }, "1")), /*#__PURE__*/React.createElement("text", {
    transform: "rotate(-29.46 102.228 -38.282)",
    fill: "#231F20",
    fontFamily: "Helvetica",
    fontSize: 4.245
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4
  }, "7")), /*#__PURE__*/React.createElement("text", {
    transform: "rotate(-29.46 51.99 -65.387)",
    fill: "#231F20",
    fontFamily: "Helvetica",
    fontSize: 4.245
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4
  }, "2")), /*#__PURE__*/React.createElement("text", {
    transform: "rotate(-29.46 94.023 -24.611)",
    fill: "#231F20",
    fontFamily: "Helvetica",
    fontSize: 4.245
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4
  }, "8")), /*#__PURE__*/React.createElement("text", {
    fill: "#231F20",
    transform: "rotate(-29.46 48.947 32.867)",
    fontFamily: "Helvetica",
    fontSize: 4.245
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 47.447,
    y: 34.367
  }, "4")), /*#__PURE__*/React.createElement("text", {
    fill: "#231F20",
    transform: "rotate(-29.46 46.498 40.276)",
    fontFamily: "Helvetica",
    fontSize: 4.245
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 44.998,
    y: 41.776
  }, "5")), /*#__PURE__*/React.createElement("text", {
    transform: "rotate(-29.46 65.726 -16.06)",
    fill: "#231F20",
    fontFamily: "Helvetica",
    fontSize: 4.245
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4
  }, "10")), /*#__PURE__*/React.createElement("text", {
    transform: "rotate(-29.46 52.39 -23.497)",
    fill: "#231F20",
    fontFamily: "Helvetica",
    fontSize: 4.245
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 4
  }, "11")), /*#__PURE__*/React.createElement("path", {
    d: "M18.026 11.173 4.604 23.993l-2.64-2.933a2.682 2.682 0 0 1 .136-3.71l9.683-9.248a2.499 2.499 0 0 1 3.603.14l2.64 2.931z",
    fill: "#007C96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.189 7.844-3.073 2.032a.477.477 0 0 1-.668-.146l-.42-.675a.477.477 0 0 1 .141-.65l3.072-2.032a.477.477 0 0 1 .669.146l.42.675a.477.477 0 0 1-.141.65z",
    fill: "#1C2D36"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#1C2D36",
    cx: 33.995,
    cy: 33.235,
    rx: 1.081,
    ry: 1.113
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C2D36",
    d: "m34.019 32.87-9.34 4.124 9.602-3.474zM34.785 33.018l2.936-15.805-4.309 15.42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.369 44.552 5.873 4.777c.024.02.05.036.08.049l3.413 1.424c.312.13.587-.254.375-.521l-2.303-2.909a.321.321 0 0 0-.058-.056l-6.004-4.606a.318.318 0 0 0-.451.064l-.98 1.312a.342.342 0 0 0 .056.467l-.001-.001z",
    fill: "#007C96"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtCardClock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-card-clock.fc48d982ae550fa68a9986ec6aa0609e.svg";